import React from 'react';
import { IconButton } from '@mui/material';

import { ReactComponent as ArrowIcon } from 'assets/images/arrow-btn.svg';
import { ReactComponent as ArrowDisabledIcon } from 'assets/images/arrow-btn-disabled.svg';

type InputProps = {
  onClick: () => void;
  disabled?: boolean;
};

export const ArrowButton = ({ onClick, disabled = false }: InputProps) => {
  return (
    <IconButton onClick={onClick}>
      {!disabled ? <ArrowIcon /> : <ArrowDisabledIcon />}
    </IconButton>
  );
};
